import {
    getLocaleData, getEstimate, getFooterLinks, updateAccount
} from './graphQlSvc';

const AppActions = {
    SET_ROOT_PATH: 'SET_ROOT_PATH',
    SET_FALLBACK_TRANSLATIONS: 'SET_FALLBACK_TRANSLATIONS',
    SET_TRANSLATIONS: 'SET_TRANSLATIONS',
    SET_LOCALE: 'SET_LOCALE',
    SET_DISPLAY_LOCALE: 'SET_DISPLAY_LOCALE',
    SET_LOCALE_LIST: 'SET_LOCALE_LIST',
    GET_LOCALE_START: 'GET_LOCALE_START',
    GET_LOCALE_SUCCESS: 'GET_LOCALE_SUCCESS',
    GET_LOCALE_FAIL: 'GET_LOCALE_FAIL',
    GET_ESTIMATE_START: 'GET_ESTIMATE_START',
    GET_ESTIMATE_SUCCESS: 'GET_ESTIMATE_SUCCESS',
    GET_ESTIMATE_FAIL: 'GET_ESTIMATE_FAIL',
    SET_QUERY: 'SET_QUERY',
    SET_REFERRER: 'SET_REFERRER',
    SET_BRAND: 'SET_BRAND',
    SET_EXPERIMENTS: 'SET_EXPERIMENTS',
    SET_PROPERTY_COUNT: 'SET_PROPERTY_COUNT',
    SET_PROPERTY_TYPE: 'SET_PROPERTY_TYPE',
    SET_IS_SAME_BUILDING: 'SET_IS_SAME_BUILDING',
    SET_DESTINATION: 'SET_DESTINATION',
    SET_USES_SOFTWARE: 'SET_USES_SOFTWARE',
    SET_ISPM: 'SET_ISPM',
    SET_XDID: 'SET_XDID',
    SET_SCROLLING: 'SET_SCROLLING',
    SET_TEMPLATE_ID: 'SET_TEMPLATE_ID',
    SET_BEDROOM_COUNT: 'SET_BEDROOM_COUNT',
    SET_BATHROOM_COUNT: 'SET_BATHROOM_COUNT',
    SET_SOFTWARE_ID: 'SET_SOFTWARE_ID',
    TOGGLE_MODAL_OPEN: 'TOGGLE_MODAL_OPEN',
    SET_HA_SESSION_V3_ID: 'SET_HA_SESSION_V3_ID',
    SET_CREATE_PROPERTY_ERROR: 'SET_CREATE_PROPERTY_ERROR',
    SET_CREATED_PROPERTY_TRIAD: 'SET_CREATED_PROPERTY_TRIAD',
    GET_FOOTER_LINKS_START: 'GET_FOOTER_LINKS_START',
    GET_FOOTER_LINKS_SUCCESS: 'GET_FOOTER_LINKS_SUCCESS',
    GET_FOOTER_LINKS_FAIL: 'GET_FOOTER_LINKS_FAIL',
    SET_USER_LOGGED_IN: 'USER_LOGGED_IN',
    SET_VRBO_OWNER_AUTH_URL: 'SET_VRBO_OWNER_AUTH_URL',
    SET_VRBO_GENERIC_AUTH_URL: 'SET_VRBO_GENERIC_AUTH_URL',
    SET_LOGGED_IN_USER_TYPE: 'SET_LOGGED_IN_USER_TYPE',
    SET_HAS_ADVERTISER_FOR_SITE: 'SET_HAS_ADVERTISER_FOR_SITE',
    SET_FINGERPRINT: 'SET_FINGERPRINT',
    SET_HAS_FULLY_AUTHENTICATED: 'SET_HAS_FULLY_AUTHENTICATED',
    CREATE_ACCOUNT_START: 'CREATE_ACCOUNT_START',
    CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT_SUCCESS',
    CREATE_ACCOUNT_FAIL: 'CREATE_ACCOUNT_FAIL',
    UPDATE_ACCOUNT_START: 'UPDATE_ACCOUNT_START',
    UPDATE_ACCOUNT_SUCCESS: 'UPDATE_ACCOUNT_SUCCESS',
    UPDATE_ACCOUNT_FAIL: 'UPDATE_ACCOUNT_FAIL',
    SET_UPDATE_ACCOUNT_IN_PROGRESS: 'SET_UPDATE_ACCOUNT_IN_PROGRESS',
    SET_SITENAME: 'SET_SITENAME',
    SET_SITE_URLS: 'SET_SITE_URLS',
    SET_AEM_DATA: 'SET_AEM_DATA',
    SET_FEATURES: 'SET_FEATURES',
    SET_POINT_OF_SALE: 'SET_POINT_OF_SALE',
    SET_EXPEDIA_ID: 'SET_EXPEDIA_ID',
    SET_INTERNAL_USER: 'SET_INTERNAL_USER',
    SET_PATH_SOURCE: 'SET_PATH_SOURCE',
    SET_VACASA_VIEWED: 'SET_VACASA_VIEWED',
    SET_IS_MODAL_OPEN: 'SET_IS_MODAL_OPEN',
    SET_DISPLAY_BRAND: 'SET_DISPLAY_BRAND',
    SET_USER_COUNTRY_CODE: 'SET_USER_COUNTRY_CODE',

    setRootPath: rootPath => ({
        type: AppActions.SET_ROOT_PATH,
        rootPath
    }),
    setTranslations: translations => ({
        type: AppActions.SET_TRANSLATIONS,
        translations
    }),
    setFallbackTranslations: translations => ({
        type: AppActions.SET_FALLBACK_TRANSLATIONS,
        translations
    }),
    setLocale: locale => ({
        type: AppActions.SET_LOCALE,
        locale
    }),
    setDisplayLocale: locale => ({
        type: AppActions.SET_DISPLAY_LOCALE,
        locale
    }),
    setLocaleList: list => ({
        type: AppActions.SET_LOCALE_LIST,
        list
    }),
    setQuery: query => ({
        type: AppActions.SET_QUERY,
        query
    }),
    setReferrer: referrer => ({
        type: AppActions.SET_REFERRER,
        referrer
    }),
    setBrand: brand => ({
        type: AppActions.SET_BRAND,
        brand
    }),
    setDisplayBrand: displayBrand => ({
        type: AppActions.SET_DISPLAY_BRAND,
        displayBrand
    }),
    setXdid: xdid => ({
        type: AppActions.SET_XDID,
        xdid
    }),
    setScrolling: scrolling => ({
        type: AppActions.SET_SCROLLING,
        scrolling
    }),
    setIsPm: isPm => ({
        type: AppActions.SET_ISPM,
        isPm
    }),
    setUsesSoftware: usesSoftware => ({
        type: AppActions.SET_USES_SOFTWARE,
        usesSoftware
    }),
    setPropertyCount: propertyCount => ({
        type: AppActions.SET_PROPERTY_COUNT,
        propertyCount
    }),
    setPropertyType: propertyType => ({
        type: AppActions.SET_PROPERTY_TYPE,
        propertyType
    }),
    setIsSameBuilding: isSameBuilding => ({
        type: AppActions.SET_IS_SAME_BUILDING,
        isSameBuilding
    }),
    setDestination: destination => ({
        type: AppActions.SET_DESTINATION,
        destination
    }),
    setBathroomCount: count => ({
        type: AppActions.SET_BATHROOM_COUNT,
        count,
        persist: true
    }),
    setBedroomCount: count => ({
        type: AppActions.SET_BEDROOM_COUNT,
        count,
        persist: true
    }),
    getLocale: (locale) => {
        const start = () => ({ type: AppActions.GET_LOCALE_START });
        const success = (localeData) => {
            if (window && window.analyticsdatalayer) {
                window.analyticsdatalayer.displaylocale = locale;
            }
            return { type: AppActions.GET_LOCALE_SUCCESS, localeData };
        };
        const fail = error => ({ type: AppActions.GET_LOCALE_FAIL, error });
        return dispatch => dispatch(getLocaleData(locale, start, success, fail));
    },
    getEstimate: (propertyInfo, locale) => {
        const start = () => ({ type: AppActions.GET_ESTIMATE_START });
        const success = estimate => ({ type: AppActions.GET_ESTIMATE_SUCCESS, estimate });
        const fail = error => ({ type: AppActions.GET_ESTIMATE_FAIL, error });
        return dispatch => dispatch(getEstimate(propertyInfo, locale, start, success, fail));
    },
    setExperiments: experiments => ({
        type: AppActions.SET_EXPERIMENTS,
        experiments
    }),
    setTemplateId: templateId => ({
        type: AppActions.SET_TEMPLATE_ID,
        templateId
    }),
    setSoftwareId: softwareId => ({
        type: AppActions.SET_SOFTWARE_ID,
        softwareId
    }),
    toggleModalOpen: modalOpen => ({
        type: AppActions.TOGGLE_MODAL_OPEN,
        modalOpen
    }),
    setCreatePropertyError: errorMessage => ({
        type: AppActions.SET_CREATE_PROPERTY_ERROR,
        errorMessage
    }),
    setCreatedPropertyTriad: triad => ({
        type: AppActions.SET_CREATED_PROPERTY_TRIAD,
        triad
    }),
    getFooterLinks: (referrerBrand, locale) => {
        const start = () => ({ type: AppActions.GET_FOOTER_LINKS_START });
        const success = links => ({ type: AppActions.GET_FOOTER_LINKS_SUCCESS, links });
        const fail = error => ({ type: AppActions.GET_FOOTER_LINKS_FAIL, error });
        return dispatch => dispatch(getFooterLinks(referrerBrand, locale, start, success, fail));
    },
    setUserLoggedIn: isLoggedIn => ({
        type: AppActions.SET_USER_LOGGED_IN,
        isLoggedIn
    }),
    setVrboOwnerAuthUrl: vrboOwnerAuthUrl => ({
        type: AppActions.SET_VRBO_OWNER_AUTH_URL,
        vrboOwnerAuthUrl
    }),
    setVrboGenericAuthUrl: vrboGenericAuthUrl => ({
        type: AppActions.SET_VRBO_GENERIC_AUTH_URL,
        vrboGenericAuthUrl
    }),
    setLoggedInUserType: loggedInUserType => ({
        type: AppActions.SET_LOGGED_IN_USER_TYPE,
        loggedInUserType
    }),
    setHasAdvertiserForSite: hasAdvertiser => ({
        type: AppActions.SET_HAS_ADVERTISER_FOR_SITE,
        hasAdvertiser
    }),
    setFingerprint: fingerprint => ({
        type: AppActions.SET_FINGERPRINT,
        fingerprint
    }),
    setHasFullyAuthenticated: hasFullyAuthenticated => ({
        type: AppActions.SET_HAS_FULLY_AUTHENTICATED,
        hasFullyAuthenticated
    }),
    setCreateAccountStart: () => ({
        type: AppActions.CREATE_ACCOUNT_START
    }),
    setCreateAccountSuccess: () => ({
        type: AppActions.CREATE_ACCOUNT_SUCCESS
    }),
    setCreateAccountFail: error => ({
        type: AppActions.CREATE_ACCOUNT_FAIL,
        error
    }),
    updateAccount: (locale, fingerprint, trustPayload) => {
        const start = () => ({ type: AppActions.UPDATE_ACCOUNT_START });
        const success = updateAccountData => ({
            type: AppActions.UPDATE_ACCOUNT_SUCCESS, updateAccountData
        });
        const fail = error => ({ type: AppActions.UPDATE_ACCOUNT_FAIL, error });
        return dispatch => dispatch(
            updateAccount(locale, fingerprint, trustPayload, start, success, fail)
        );
    },
    setUpdateAccountInProgress: updateAccountInProgress => ({
        type: AppActions.SET_UPDATE_ACCOUNT_IN_PROGRESS,
        updateAccountInProgress
    }),
    setSiteName: siteName => ({
        type: AppActions.SET_SITENAME,
        siteName
    }),
    setSiteUrls: urls => ({
        type: AppActions.SET_SITE_URLS,
        urls
    }),
    setAemData: aemData => ({
        type: AppActions.SET_AEM_DATA,
        aemData
    }),
    setFeatures: features => ({
        type: AppActions.SET_FEATURES,
        features
    }),
    setPointOfSale: pos => ({
        type: AppActions.SET_POINT_OF_SALE,
        pos
    }),
    setExpediaId: expediaId => ({
        type: AppActions.SET_EXPEDIA_ID,
        expediaId
    }),
    setInternalUser: isInternalUser => ({
        type: AppActions.SET_INTERNAL_USER,
        isInternalUser
    }),
    setPathSource: source => ({
        type: AppActions.SET_PATH_SOURCE,
        source,
        persist: true
    }),
    setVacasaViewed: isVacasaViewed => ({
        type: AppActions.SET_VACASA_VIEWED,
        isVacasaViewed,
        persist: true
    }),
    setIsModalOpen: isModalOpen => ({
        type: AppActions.SET_IS_MODAL_OPEN,
        isModalOpen
    }),
    setUserCountryCode: userCountryCode => ({
        type: AppActions.SET_USER_COUNTRY_CODE,
        userCountryCode
    })
};

export default AppActions;
